module.exports = __webpack_public_path__ + "static/media/background-texture.318787a8.jpg";